import React from "react";
import { Box, MenuItem, TextField, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { PropTypes } from "prop-types";

const useStyles = makeStyles(theme => ({
  select: {
    ...theme.components.MuiTypography.styleOverrides.h6,
    fontSize: "1.5rem",
    color: theme.palette.text.primary,
    padding: "19px 0px 9px 16px ",
    backgroundColor: "transparent"
  },
  textField: {
    backgroundColor: "transparent"
  }
}));

const ModalTitleDropdown = ({
  label,
  value,
  options,
  onChange,
  selectWidth
}) => {
  const classes = useStyles();
  return (
    <Box display="flex" flex={1} alignItems="center" flexWrap="wrap" my={-1.5}>
      <Typography
        variant="h6"
        sx={{ mr: 1, pr: 2 }}
        color="textSecondary"
        id="modal-title-dropdown-label"
      >
        {label}
      </Typography>
      <Box width={selectWidth} ml={-2}>
        <TextField
          select
          value={value}
          onChange={ev => onChange(ev.target.value)}
          variant="filled"
          InputProps={{
            className: classes.textField,
            disableUnderline: true,
            inputProps: {
              "data-qa": "modal-title-dropdown-input"
            }
          }}
          SelectProps={{
            labelId: "modal-title-dropdown-label",
            classes: { select: classes.select },
            SelectDisplayProps: {
              "data-qa": "modal-title-dropdown-select"
            }
          }}
          fullWidth
          hiddenLabel
        >
          {options.map(({ value, label }) => (
            <MenuItem value={value} key={value}>
              {label}
            </MenuItem>
          ))}
        </TextField>
      </Box>
    </Box>
  );
};

export default ModalTitleDropdown;

ModalTitleDropdown.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  options: PropTypes.array,
  selectWidth: PropTypes.number,
  onChange: PropTypes.func
};

ModalTitleDropdown.defaultProps = {
  selectWidth: 260
};
